// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
This computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), 
is the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.
*/

/* Note:Using 2 type of Switch Components so we are using two different ClassNames Used*/

.switch {
  /* display: flex; */
  align-items: center;
  /* gap: 0.5rem; */
  display: flex;
  gap: 8.5rem;
  align-items: center;
  flex-direction: row;
  flex-wrap: nowrap;
}

.switch .switch_unStyle .unStyled {
  font-size: 0;
  position: relative;
  display: inline-block;
  width: 40px;
  height: 24px;
  margin: 10px;
  cursor: pointer;
}

.switch .switch_unStyle .MuiSwitch-input {
  cursor: inherit;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  opacity: 0;
  z-index: 1;
  margin: 0;
}

.switch .switch_unStyle .MuiSwitch-root {
  font-size: 0;
  position: relative;
  display: inline-block;
  width: 43.57px;
  height: 21.79px;
  margin: 10px;
  cursor: pointer;
}

.switch .switch_unStyle .MuiSwitch-root.Mui-disabled {
  cursor: unset;
}

.switch .switch_unStyle .MuiSwitch-track {
  background: var(--inputControlBackgroundColor);
  border: var(--unStyledSwitchColor) solid 1px;
  border-radius: 16px;
  display: block;
  height: 100%;
  width: 100%;
  position: absolute;
}

.switch .switch_unStyle .MuiSwitch-thumb {
  display: block;
  width: 13.08px;
  height: 13.08px;
  top: 4.7px;
  left: 6px;
  border-radius: 16px;
  background-color: var(--unStyledSwitchColor);
  position: relative;
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 120ms;
}

.switch .unstyle {
  font-size: var(--default-FontSize);
  height: 21px;
  font-family: var(--label-FontName);
}

.switch_unStyle {
  height: 43.56px;
  line-height: 43.56px;
}

.formviewer .switch .switch__label {
  overflow-wrap: anywhere;
  font-family: var(--label-FontName);
  font-size: var(--label-FontSize);
  font-weight: var(--label-FontWeight);
  color: var(--label-FontColour);
}

.tab-panel .switch .switch__label {
  font-family: var(--label-FontName);
  font-size: var(--label-FontSize);
  font-weight: var(--label-FontWeight);
  color: var(--label-FontColour);
  justify-content: var(--textahrlignment);
}

.switch .Mui-checked .MuiSwitch-thumb {
  left: 25px;
  top: 4px;
  background-color: var(--inputControlBackgroundColor);
}

.switch .Mui-checked .MuiSwitch-track {
  background-color: rgba(31, 60, 136, 0.5);
}

.icon-padding {
  display: flex;
  align-items: center;
  padding: 0 5px;
}

.switch .ControlLabelDiv {
  display: flex;
  align-items: center;
  gap: 0.25rem;
}

.Required-color {
  color: var(--mandatorySymbol);
}

.checkboxControl .MuiButtonBase-root {
  padding: 9px 9px 9px 5px;
}

.filterColumnContentMainSection
  .filterColumnContentSection
  .checkboxControl
  .MuiButtonBase-root {
  padding: 9px !important;
}

.homepagemainsection .homepagetoolsection .switch {
  display: flex;
  gap: 0;
  align-items: center;
  flex-direction: row-reverse;
  flex-wrap: nowrap;
}

.homepagemainsection .homepagetoolsection .switch .unstyle {
  font-weight: var(--header-FontWeight);
  color: var(--default-FontColour);
}

.homepagemainsection
  .homepagetoolsection
  .switch
  .switch_unStyle
  .MuiSwitch-root {
  margin: 12px 10px 10px 10px;
}

.switch .placeholder {
  font-family: var(--default-FontName);
  font-size: var(--default-FontSize);
  font-weight: var(--default-FontWeight);
  color: var(--placeHolderColor);
}

.switch .horizontalPlaceholder {
  display: grid;
  grid-template-columns: auto auto;
  align-items: center;
}

.switch .verticalPlaceholder {
  display: grid;
  grid-template-columns: auto auto;
}

/*gridControl -- start*/
.gridControl.switch.active .Mui-checked .MuiSwitch-track {
  background-color: var(--unStyledSwitchColor);
}

.gridControl.switch.active .switch_unStyle .MuiSwitch-track {
  border: 1.08889px solid var(--unStyledSwitchColor);
}

.gridControl.switch.active .switch_unStyle .MuiSwitch-thumb {
  background-color: var(--unStyledSwitchColor);
}

.gridControl.switch.active .Mui-checked .MuiSwitch-thumb {
  background-color: var(--inputControlBackgroundColor);
}

.gridControl.switch .switch_unStyle .MuiSwitch-root {
  cursor: default;
}

.prefixGridSection .switch .switch_unStyle .MuiSwitch-root {
  margin: 11px 0px 10px 0px;
}

.personalInfoHeader .userStatus .switch,
.header .switch,
.wf_auto_assign_switch .switch {
  gap: 6px;
}

.header .switch .control,
.personalData .userStatus .switch .control,
.wf_auto_assign_switch .switch .control {
  margin-top: -2px;
}

.userSetupPage .switch .Mui-checked .MuiSwitch-track,
.header .switch .Mui-checked .MuiSwitch-track {
  background-color: var(--unStyledSwitchColor);
  border: unset;
}

.userSetupPage .header .switch .switch_unStyle .MuiSwitch-root {
  margin-right: 0;
}

/*gridControl -- end*/

.userSetupPage .switch .MuiSwitch-root.Mui-checked .MuiSwitch-thumb {
  background-color: var(--ToolbarBackgroundColour);
}

.userSetupPage .switch .MuiSwitch-root .MuiSwitch-thumb {
  background-color: var(--unStyledSwitchColor);
}

.userSetupPage .switch .MuiSwitch-root .MuiSwitch-track {
  border: 1px solid var(--unStyledSwitchColor);
}

.userSetupPage .switch .switch__input {
  margin-top: 3.5px;
}
`, "",{"version":3,"sources":["webpack://./src/views/components/base/switch/Switch.css"],"names":[],"mappings":"AAAA;;;CAGC;;AAED,wFAAwF;;AAExF;EACE,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,MAAM;EACN,OAAO;EACP,UAAU;EACV,UAAU;EACV,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,8CAA8C;EAC9C,4CAA4C;EAC5C,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,UAAU;EACV,SAAS;EACT,mBAAmB;EACnB,4CAA4C;EAC5C,kBAAkB;EAClB,wBAAwB;EACxB,wDAAwD;EACxD,0BAA0B;AAC5B;;AAEA;EACE,kCAAkC;EAClC,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,kCAAkC;EAClC,gCAAgC;EAChC,oCAAoC;EACpC,8BAA8B;AAChC;;AAEA;EACE,kCAAkC;EAClC,gCAAgC;EAChC,oCAAoC;EACpC,8BAA8B;EAC9B,uCAAuC;AACzC;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,oDAAoD;AACtD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;;;EAIE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,MAAM;EACN,mBAAmB;EACnB,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,qCAAqC;EACrC,gCAAgC;AAClC;;AAEA;;;;;EAKE,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,kCAAkC;EAClC,sCAAsC;EACtC,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gCAAgC;AAClC;;AAEA,uBAAuB;AACvB;EACE,4CAA4C;AAC9C;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;EAGE,QAAQ;AACV;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;;EAEE,4CAA4C;EAC5C,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA,qBAAqB;;AAErB;EACE,gDAAgD;AAClD;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":["/*\nThis computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), \nis the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.\n*/\n\n/* Note:Using 2 type of Switch Components so we are using two different ClassNames Used*/\n\n.switch {\n  /* display: flex; */\n  align-items: center;\n  /* gap: 0.5rem; */\n  display: flex;\n  gap: 8.5rem;\n  align-items: center;\n  flex-direction: row;\n  flex-wrap: nowrap;\n}\n\n.switch .switch_unStyle .unStyled {\n  font-size: 0;\n  position: relative;\n  display: inline-block;\n  width: 40px;\n  height: 24px;\n  margin: 10px;\n  cursor: pointer;\n}\n\n.switch .switch_unStyle .MuiSwitch-input {\n  cursor: inherit;\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  opacity: 0;\n  z-index: 1;\n  margin: 0;\n}\n\n.switch .switch_unStyle .MuiSwitch-root {\n  font-size: 0;\n  position: relative;\n  display: inline-block;\n  width: 43.57px;\n  height: 21.79px;\n  margin: 10px;\n  cursor: pointer;\n}\n\n.switch .switch_unStyle .MuiSwitch-root.Mui-disabled {\n  cursor: unset;\n}\n\n.switch .switch_unStyle .MuiSwitch-track {\n  background: var(--inputControlBackgroundColor);\n  border: var(--unStyledSwitchColor) solid 1px;\n  border-radius: 16px;\n  display: block;\n  height: 100%;\n  width: 100%;\n  position: absolute;\n}\n\n.switch .switch_unStyle .MuiSwitch-thumb {\n  display: block;\n  width: 13.08px;\n  height: 13.08px;\n  top: 4.7px;\n  left: 6px;\n  border-radius: 16px;\n  background-color: var(--unStyledSwitchColor);\n  position: relative;\n  transition-property: all;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  transition-duration: 120ms;\n}\n\n.switch .unstyle {\n  font-size: var(--default-FontSize);\n  height: 21px;\n  font-family: var(--label-FontName);\n}\n\n.switch_unStyle {\n  height: 43.56px;\n  line-height: 43.56px;\n}\n\n.formviewer .switch .switch__label {\n  overflow-wrap: anywhere;\n  font-family: var(--label-FontName);\n  font-size: var(--label-FontSize);\n  font-weight: var(--label-FontWeight);\n  color: var(--label-FontColour);\n}\n\n.tab-panel .switch .switch__label {\n  font-family: var(--label-FontName);\n  font-size: var(--label-FontSize);\n  font-weight: var(--label-FontWeight);\n  color: var(--label-FontColour);\n  justify-content: var(--textahrlignment);\n}\n\n.switch .Mui-checked .MuiSwitch-thumb {\n  left: 25px;\n  top: 4px;\n  background-color: var(--inputControlBackgroundColor);\n}\n\n.switch .Mui-checked .MuiSwitch-track {\n  background-color: rgba(31, 60, 136, 0.5);\n}\n\n.icon-padding {\n  display: flex;\n  align-items: center;\n  padding: 0 5px;\n}\n\n.switch .ControlLabelDiv {\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n}\n\n.Required-color {\n  color: var(--mandatorySymbol);\n}\n\n.checkboxControl .MuiButtonBase-root {\n  padding: 9px 9px 9px 5px;\n}\n\n.filterColumnContentMainSection\n  .filterColumnContentSection\n  .checkboxControl\n  .MuiButtonBase-root {\n  padding: 9px !important;\n}\n\n.homepagemainsection .homepagetoolsection .switch {\n  display: flex;\n  gap: 0;\n  align-items: center;\n  flex-direction: row-reverse;\n  flex-wrap: nowrap;\n}\n\n.homepagemainsection .homepagetoolsection .switch .unstyle {\n  font-weight: var(--header-FontWeight);\n  color: var(--default-FontColour);\n}\n\n.homepagemainsection\n  .homepagetoolsection\n  .switch\n  .switch_unStyle\n  .MuiSwitch-root {\n  margin: 12px 10px 10px 10px;\n}\n\n.switch .placeholder {\n  font-family: var(--default-FontName);\n  font-size: var(--default-FontSize);\n  font-weight: var(--default-FontWeight);\n  color: var(--placeHolderColor);\n}\n\n.switch .horizontalPlaceholder {\n  display: grid;\n  grid-template-columns: auto auto;\n  align-items: center;\n}\n\n.switch .verticalPlaceholder {\n  display: grid;\n  grid-template-columns: auto auto;\n}\n\n/*gridControl -- start*/\n.gridControl.switch.active .Mui-checked .MuiSwitch-track {\n  background-color: var(--unStyledSwitchColor);\n}\n\n.gridControl.switch.active .switch_unStyle .MuiSwitch-track {\n  border: 1.08889px solid var(--unStyledSwitchColor);\n}\n\n.gridControl.switch.active .switch_unStyle .MuiSwitch-thumb {\n  background-color: var(--unStyledSwitchColor);\n}\n\n.gridControl.switch.active .Mui-checked .MuiSwitch-thumb {\n  background-color: var(--inputControlBackgroundColor);\n}\n\n.gridControl.switch .switch_unStyle .MuiSwitch-root {\n  cursor: default;\n}\n\n.prefixGridSection .switch .switch_unStyle .MuiSwitch-root {\n  margin: 11px 0px 10px 0px;\n}\n\n.personalInfoHeader .userStatus .switch,\n.header .switch,\n.wf_auto_assign_switch .switch {\n  gap: 6px;\n}\n\n.header .switch .control,\n.personalData .userStatus .switch .control,\n.wf_auto_assign_switch .switch .control {\n  margin-top: -2px;\n}\n\n.userSetupPage .switch .Mui-checked .MuiSwitch-track,\n.header .switch .Mui-checked .MuiSwitch-track {\n  background-color: var(--unStyledSwitchColor);\n  border: unset;\n}\n\n.userSetupPage .header .switch .switch_unStyle .MuiSwitch-root {\n  margin-right: 0;\n}\n\n/*gridControl -- end*/\n\n.userSetupPage .switch .MuiSwitch-root.Mui-checked .MuiSwitch-thumb {\n  background-color: var(--ToolbarBackgroundColour);\n}\n\n.userSetupPage .switch .MuiSwitch-root .MuiSwitch-thumb {\n  background-color: var(--unStyledSwitchColor);\n}\n\n.userSetupPage .switch .MuiSwitch-root .MuiSwitch-track {\n  border: 1px solid var(--unStyledSwitchColor);\n}\n\n.userSetupPage .switch .switch__input {\n  margin-top: 3.5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
